// extracted by mini-css-extract-plugin
export default {"tile_information":"charts_tile_information__Yuj0X","tile_title":"charts_tile_title__iIyer","chart_shadow":"charts_chart_shadow__haLNe","opacity":"charts_opacity__qP02J"};